// extracted by mini-css-extract-plugin
module.exports = {"ProductComparison":"ProductComparison_ProductComparison__5zabV"};